// Self-registering plugin for the private help center ("Private KB").
// Registers the role-agnostic read-only knowledge base launcher route.
// Called once from `app/javascript/entrypoints/dashboard.js`.
import KbBrowserPage from './KbBrowserPage.vue';

export const KB_BROWSER_ROUTE_NAME = 'custom_kb_browser';

export const installHelpCenterPrivate = ({ router }) => {
  if (!router || router.hasRoute(KB_BROWSER_ROUTE_NAME)) return;

  const route = {
    name: KB_BROWSER_ROUTE_NAME,
    path: '/app/accounts/:accountId/custom/knowledge-base',
    component: KbBrowserPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  };

  // Mount inside the dashboard shell (AppContainer) so the left sidebar is
  // kept and the KB renders in the main content area. Fall back to a top-level
  // route if the named parent is unavailable.
  if (router.hasRoute('app_container')) {
    router.addRoute('app_container', route);
  } else {
    router.addRoute(route);
  }
};

export default installHelpCenterPrivate;
